import BaseHelper from './BaseHelper'

export default class TitlesHelper extends BaseHelper {
  static configName = 'TitlesHelper'

  static defaultConfig = {
    index: 110,
    x: {
      type: [String, null],
      default: null,
      exposed: true,
    },
    y: {
      type: [String, null],
      default: null,
      exposed: true,
    }
  }

  static init() {
    this.$grid = null
    let node = this.$root
    while (!this.$grid) {
      if (!node.parentElement) {
        break
      }

      if (node.classList.contains('cols-wrapper')) {
        this.$grid = node
      } else {
        node = node.parentElement
      }
    }

    if (!this.$grid) return

    this.grid = {
      top: this.$grid.querySelector('.row-top'),
      bottom: this.$grid.querySelector('.row-bottom'),
      left: this.$grid.querySelector('.col-left'),
      right: this.$grid.querySelector('.col-right'),
    }

    this.grid.top.style.display = "flex";
    this.grid.bottom.style.display = "flex";

    this.grid.left.style.display = "flex";
    this.grid.left.style.flexDirection = "column";
    this.grid.right.style.display = "flex";
    this.grid.right.style.flexDirection = "column";
  }

  static update() {
    this.grid.top.style.marginLeft = this.config.AxisHelper.margin.left / 2 + "px";
    this.grid.top.style.marginRight = this.config.AxisHelper.margin.right + "px";
    this.grid.top.innerHTML = this.config.TitlesHelper.y;

    this.grid.bottom.style.marginLeft = this.config.AxisHelper.margin.left / 2 + "px";
    this.grid.bottom.style.marginRight = this.config.AxisHelper.margin.right + "px";
    this.grid.bottom.innerHTML = this.config.TitlesHelper.x;
  }
}
